import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';
import { ArbitrosService } from '../../services/arbitros/arbitros.service';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';

declare const resaltarPestañaMenu:any;

@Component({
    selector: 'app-arbitros',
    templateUrl: './arbitros.component.html',
    styleUrls: ['./arbitros.component.css'],
    standalone: false
})
export class ArbitrosComponent extends BaseComponent implements OnInit {

  arbitros:any[]=[];
  arbitro:any;
  tipo_arbitro:any={clases:[]};
  tipo_disciplina:any={clases:[]};
  roles:any[]=[];

  modal_arbitro:NgbModalRef;
  @ViewChild('modal_arbitro')
  private modal_arbitro_ref: TemplateRef<any>;

  constructor(private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public arbitrosService:ArbitrosService){
      super(persistenciaService,modalService,generalService,usuarioService);
    }

  async ngOnInit(): Promise<void> {
    this.init();
    this.buscarAplicacion(this.router.url.substring(1));
    this.configuracion_pagina={};
    await this.obtenerTiposArbitro();
    await this.obtenerDisciplinas();
    this.filter={
      id_empresa:this.usuario.id_empresa,
      tipos:[{nombre:"TODOS",id:0}].concat(this.tipo_arbitro.clases),
      tipo:{nombre:"TODOS",id:0},
      disciplinas:[{nombre:"TODAS",id:0}].concat(this.tipo_disciplina.clases),
      disciplina:{nombre:"TODAS",id:0}
    };
    this.column="updatedAt";
    this.direction="desc";
    this.getSearch(this.text_search,null);
  }

  ngAfterViewInit() {
    resaltarPestañaMenu(this.router.url.substring(1)+"1");
  }

  async obtenerTiposArbitro(){
    this.tipo_arbitro=await this.generalService.obtenerClases(GlobalVariable.Dictionary.TOR.TIPO_ARBITRO).toPromise();
  }

  async obtenerDisciplinas(){
    this.tipo_disciplina=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,
                              GlobalVariable.Dictionary.TIPO_EQUIPO_DISCIPLINAS).toPromise();
  }

  /* Las disciplinas guardan su color en nombre_corto, igual que en el rol de partidos. */
  colorClase(clase){
    return (clase && clase.nombre_corto && String(clase.nombre_corto).charAt(0)=="#")?clase.nombre_corto:null;
  }

  getItems(){
    this.blockUI.start('Recuperando... espere por favor!');
    this.arbitrosService.obtenerListaArbitros(this).subscribe((dato:any) => {
      this.setPages(dato.paginas);
      this.arbitros=dato.arbitros;
      this.blockUI.stop();
    });
  }

  crearNuevoArbitro(){
    this.arbitro={
      id_empresa:this.usuario.id_empresa,
      codigo:"",
      tipo:this.tipo_arbitro.clases[0],
      //sin disciplina queda de comodin: el fixture puede darle partidos de cualquiera
      disciplina:null,
      persona:{},
      activo:true,
      //el usuario es opcional: un arbitro puede existir sin acceso al sistema
      tiene_usuario:false,
      usuario:{ nombre_usuario:"", clave:"", activo:true }
    };
    this.abrirRegistroArbitro();
  }

  modificarArbitro(arbitro){
    this.arbitro=JSON.parse(JSON.stringify(arbitro));
    this.arbitro.id_empresa=this.usuario.id_empresa;
    this.arbitro.tipo=this.tipo_arbitro.clases.filter(clase => clase.id==arbitro.id_tipo)[0];
    let disciplina=this.tipo_disciplina.clases.filter(clase => clase.id==arbitro.id_disciplina)[0];
    this.arbitro.disciplina=disciplina?disciplina:null;
    this.arbitro.tiene_usuario=!!(arbitro.persona && arbitro.persona.usuario);
    //la clave nunca vuelve del servidor; se deja vacia y solo se manda si escriben una nueva
    let usuario_previo=(arbitro.persona && arbitro.persona.usuario)?arbitro.persona.usuario:null;
    this.arbitro.usuario=usuario_previo?
      { nombre_usuario:usuario_previo.nombre_usuario, clave:"", activo:usuario_previo.activo }:
      { nombre_usuario:"", clave:"", activo:true };
    this.abrirRegistroArbitro();
  }

  abrirRegistroArbitro(){
    this.modal_arbitro=this.modalService.open(this.modal_arbitro_ref,
      {ariaLabelledBy:'modal-basic-title',size:'md',backdrop:'static'});
    this.modal_arbitro.result.then((result) => {
      this.closeResult=`Closed with: ${result}`;
    }, (reason) => {
      this.closeResult=`Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  validarArbitro(){
    let res=true;
    if(!this.arbitro.persona.nombres){
      this.toastr.error("Debe especificar los nombres!");
      res=false;
    }
    if(!this.arbitro.persona.apellido_paterno){
      this.toastr.error("Debe especificar el apellido paterno!");
      res=false;
    }
    if(!this.arbitro.tipo){
      this.toastr.error("Debe especificar el tipo de árbitro!");
      res=false;
    }
    if(this.arbitro.tiene_usuario){
      if(!this.arbitro.usuario.nombre_usuario){
        this.toastr.error("Debe especificar el nombre de usuario!");
        res=false;
      }
      //al crear el usuario la clave es obligatoria; al modificarlo, solo si la quieren cambiar
      if(!this.arbitro.usuario.clave && !this.arbitro.id){
        this.toastr.error("Debe especificar la clave del usuario!");
        res=false;
      }
    }
    return res;
  }

  guardarArbitro(){
    if(!this.validarArbitro()){
      return;
    }
    let datos=JSON.parse(JSON.stringify(this.arbitro));
    if(!datos.tiene_usuario){
      datos.usuario=null;
    }
    this.blockUI.start();
    if(this.arbitro.id){
      this.arbitrosService.actualizarArbitro(datos).subscribe((res:any) => {
        this.blockUI.stop();
        this.toastr.success(res.mensaje);
        this.modal_arbitro.close();
        this.getItems();
      });
    }else{
      this.arbitrosService.guardarArbitro(datos).subscribe((res:any) => {
        this.blockUI.stop();
        this.toastr.success(res.mensaje);
        this.modal_arbitro.close();
        this.getItems();
      });
    }
  }

  abrirPopupConfirmacionEliminacion(arbitro){
    this.popupConfirmacion=this.modalService.open(PopupConfirmacionComponent);
    this.popupConfirmacion.componentInstance.message="¿Esta seguro(a) de dar de baja al árbitro "+
      arbitro.persona.nombre_completo+"? Seguirá figurando en los partidos ya programados.";
    this.popupConfirmacion.componentInstance.data=arbitro;

    this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
      if($e.confirm){
        this.eliminarArbitro($e.data);
      }
      this.popupConfirmacion.close();
    });
  }

  eliminarArbitro(arbitro){
    this.blockUI.start();
    this.arbitrosService.eliminarArbitro(arbitro).subscribe((res:any) => {
      this.blockUI.stop();
      this.toastr.success(res.mensaje);
      this.getItems();
    });
  }
}
